<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-col v-if="estadoQr == 0">
          <b-row class="mb-4">
            <h3>Registro de entrada</h3>

            <b-col class="d-flex flex-row-reverse">
              <b-button class="ml-3" variant="primary" @click="decodificadoBoton">Registrar con codigo</b-button>
              <b-form-input id="codigo" v-model="codigoTexto" trim upper></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <qrcode-stream @decode="decodificado"></qrcode-stream>
          </b-row>
        </b-col>

        <div v-else-if="estadoQr == 1">
          <b-row>
            <b-col>
              <h3>Registro de entrada</h3>
            </b-col>
          </b-row>

          <b-row class="mt-2" v-if="$auth.can('registrar_acceso')">
            <b-col>
              <h5>Aforo actual</h5>
              <b-progress :max="aforo.max" height="2rem" v-if="aforo.cantidad != 0" class="mb-4">
                <b-progress-bar :value="aforo.cantidad">
                  <span><strong>{{ aforo.cantidad }} / {{ aforo.max }}</strong></span>
                </b-progress-bar>
              </b-progress>
              <div v-else class="mb-2">
                <b-alert class="mt-2" show>No hay personal dentro de las instalaciones</b-alert>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="mb-3">Informacion Personal</h5>

              <label for="codigo">Código/Identificación</label>
              <b-form-input id="codigo" v-model="persona.codigo" trim readonly></b-form-input>

              <label for="rol">Rol</label>
              <b-form-input id="rol" v-model="persona.perfil" trim readonly></b-form-input>

              <label for="nombre">Nombre</label>
              <b-form-input id="nombre" v-model="persona.nombre" trim readonly></b-form-input>

              <label for="programa">{{
                ['EMPLEADO', 'INVITADO'].includes(persona.perfil) ? 'Dependencia' : 'Programa'
              }}</label>
              <b-form-input id="programa" v-model="persona.programa" trim readonly></b-form-input>

            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col>
              <b-row class="mb-3">
                <b-col>
                  <h5 class="mb-3">Autorizaciones</h5>
                </b-col>
                <b-col class="d-flex flex-row-reverse">
                  <strong>
                    <h5>
                      {{ dias[dia.getDay()] + ' ' + dia.getDate() }} de
                      {{ meses[dia.getMonth()] }}
                    </h5>
                  </strong>
                </b-col>
              </b-row>

              <b-row class="mb-2 mt-2" v-if="alertaHorario">
                <b-col>
                  <b-alert variant="danger" show>No tiene autorizacion para este horario</b-alert>
                </b-col>
              </b-row>

              <b-table responsive striped hover :items="persona.horario" :fields="campos">
              </b-table>
            </b-col>
          </b-row>

          <!-- Alertas -->
          <b-row class="mt-3 mb-2" v-if="alertaDelDia">
            <b-col>
              <b-alert variant="danger" show>Cuenta con alertas importantes, se recomienda no permitir
                ingreso</b-alert>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-2" v-if="!alertaDelDia && sinAlertas">
            <b-col>
              <b-alert variant="success" show>Sin alertas</b-alert>
            </b-col>
          </b-row>

          <b-row>
            <b-col v-if="$auth.can('registrar_acceso')">
              <h5 class="mv-3">Alertas Manuales</h5>
              <b-form-checkbox-group v-model="alertasManualesSel" :options="alertasManualesPerfil" value-field="identificador" text-field="descripcion" name="manuales" stacked></b-form-checkbox-group>
              <label class="mt-2" for="temp">Temperatura</label>
              <b-form-input type="number" step="0.1" min="34" max="50" id="temp" v-model="persona.temperatura"></b-form-input>
            </b-col>

            <b-col>
              <h5 class="mv-3">Alertas Automaticas</h5>
              <b-form-checkbox-group v-model="alertasAutomaticasSel" :options="alertasAutomaticasPerfil" value-field="identificador" text-field="descripcion" name="automaticas" disabled stacked></b-form-checkbox-group>
            </b-col>

            <!-- Acceso permitido o denegado (lateral) -->
            <b-col class="d-flex flex-column align-items-center justify-content-center" md="2">
              <div class="mt-3">
                <svg v-if="sinAlertas" width="7em" height="2em" viewBox="0 0 16 16" class="bi bi-check-circle-fill" fill="#1BB55C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
                <svg v-else width="7em" height="2em" viewBox="0 0 16 16" class="bi bi-x-octagon-fill" fill="#E74C3C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                </svg>
              </div>
            </b-col>
          </b-row>

          <!-- Observaciones -->
          <b-row class="mt-2" v-if="$auth.can('registrar_acceso')">
            <b-col>
              <h5>Observaciones</h5>
              <b-form-input id="comentarios" v-model="observaciones" trim></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-5 mb-3">
            <b-col>
              <b-button variant="primary" @click="reiniciarQr()">Escanear otro codigo</b-button>
            </b-col>
            <b-col class="d-flex flex-row-reverse">
              <b-button v-if="$auth.can('registrar_acceso')" class="ml-3" variant="success" @click="cargarModal(true)" :disabled="!botonActivado">Registrar Ingreso</b-button>
              <b-button v-if="$auth.can('registrar_acceso')" variant="danger" @click="cargarModal(false)" :disabled="!botonActivado">Denegar Ingreso</b-button>
            </b-col>
          </b-row>
        </div>

        <!-- Mensaje de error -->
        <div v-else>
          <b-row>
            <b-col>
              <h3>Registro de entrada</h3>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <!-- Acceso permitido o denegado (lateral) -->
            <b-col class="d-flex flex-column align-items-center justify-content-center">
              <h5 v-if="estadoQr == 2">
                El usuario no ha completado la encuesta
              </h5>
              <h5 v-if="estadoQr == 3">
                El codigo QR no es valido o no se han encontrado el codigo en la
                base de datos
              </h5>
              <h5 v-if="estadoQr == 4">No se han ingresado datos</h5>
              <h5 v-if="estadoQr == 5">Verificando acceso</h5>

              <div class="mt-4 mb-5">
                <svg width="7em" height="2em" viewBox="0 0 16 16" class="bi bi-x-octagon-fill" fill="#E74C3C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                </svg>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-3 ">
            <b-col class="d-flex flex-column align-items-center justify-content-center">
              <b-button variant="primary" @click="reiniciarQr()">Escanear otro codigo</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!-- Modal de ingreso con alertas -->
    <b-modal v-model="modalIngreso" size="lg" no-close-on-backdrop>
      <p class="my-4">
        ¿Está seguro que desea registrar este ingreso? Tenga en cuenta que posee
        alertas importantes y podría representar un riesgo
      </p>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="registrarIngreso()">Registrar Ingreso</b-button>
        <b-button variant="danger" @click="cancel()">Cancelar</b-button>
      </template>
    </b-modal>

    <!-- Modal denegacion -->
    <b-modal v-model="modalDenegado" size="lg" no-close-on-backdrop>
      <p class="my-4">¿Está seguro que desea denegar este ingreso?</p>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="registrarIngreso(false)">Denegar Ingreso</b-button>
        <b-button variant="danger" @click="cancel()">Cancelar</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
// Sin TypeScript
import axios from 'axios'
import _ from 'lodash'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { url } from '../../../services/url_service'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

import seval from 'notevil'

@Component({
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
  },
})
export default class RegistoEntrada extends Vue {
  public dias: Array<string> = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
  ]

  meses: Array<string> = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]

  // Pantalla 1
  public codigoTexto: string = ''
  public estadoQr: number = 0
  public botonActivado: boolean = false
  public alertaDelDia: boolean = false
  public alertaHorario: boolean = false
  public personalData: any = {}
  public observaciones: string = ''
  public persona: any = {
    codigo: '',
    rol: '',
    nombre: '',
    programa: '',
    //autorizado: '',
    horario: [],
    temperatura: '',
    observaciones: '',
  }
  public comentariosAdicionales: string = ''
  public modalIngreso: boolean = false
  public modalDenegado: boolean = false

  public aforo: any = {
    cantidad: '',
    max: '',
  }

  public campos: Array<any> = [
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'nrc',
      label: 'NRC',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de Entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de Salida',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
  ]

  // Validadores
  public aforoCompleto: boolean = false
  //public validezFormulario: boolean = false
  //public sinAlertas: boolean = false

  // Opciones de alertas
  public alertasManualesSel: Array<any> = [] // Must be an array reference!
  public alertasManuales: Array<any> = []
  public alertasAutomaticasSel: Array<any> = [] // Must be an array reference!
  public alertasAutomaticas: Array<any> = []
  public alertas: Array<any> = []
  public alertasAcciones: Array<any> = []
  public ingreso: any = null
  public caracterizacion: any = null

  public get dia(): Date {
    return new Date()
  }

  public get sinAlertas(): boolean {
    // console.log(this.alertasAutomaticasSel)
    // console.log(this.alertasManualesSel)
    return (
      this.alertasAutomaticasSel.length === 0 &&
      this.alertasManualesSel.length === 0
    )
  }

  public get alertasManualesPerfil(): Array<any> {
    let self = this
    return this.alertasManuales.filter(function (alerta) {
      //console.log(self.persona.perfil)
      //console.log(alerta.perfiles)
      return alerta.perfiles.includes(self.persona.perfil)
    })
  }

  public get alertasAutomaticasPerfil(): Array<any> {
    let self = this
    return this.alertasAutomaticas.filter(function (alerta) {
      //console.log(self.persona.perfil)
      //console.log(alerta.perfiles)
      return alerta.perfiles.includes(self.persona.perfil) || ['horario', 'temperatura', 'sin_encuesta'].includes(alerta.identificador)
    })
  }

  public preLectura() {
    this.estadoQr = 5
    return true
  }

  public decodificado(decodedString) {
    var ourJson, payload

    try {
      ourJson = JSON.parse(decodedString)
      payload = {
        codigo: ourJson['codigo'],
      }
      this.codigoTexto = payload.codigo.toUpperCase()
      this.validarDatos(this.codigoTexto)
    } catch (error) {
      this.estadoQr = 3
    }
  }

  public decodificadoBoton() {
    var codigoTexto = this.codigoTexto.toUpperCase()

    if (codigoTexto == null || codigoTexto == '') {
      this.estadoQr = 4
    } else {
      this.validarDatos(codigoTexto)
    }
  }

  public validarDatos(codigo) {
    if (codigo == null || codigo == '') {
      this.estadoQr = 4
    } else {
      this.cargarDatos(codigo)
      this.estadoQr = 1
    }
  }

  public reiniciarQr() {
    this.codigoTexto = ''
    this.estadoQr = 0
    this.botonActivado = false

    this.persona.codigo = 'ND'
    this.persona.perfil = 'ND'
    this.persona.nombre = 'ND'
    this.persona.programa = 'ND'
    //this.persona.autorizado = 'ND'
    this.persona.horario = []
    this.persona.temperatura = null
    this.persona.observaciones = ''
  }

  // Alertas
  public async cargarAlertas() {
    this.alertasManuales = []
    this.alertasManualesSel = []
    this.alertasAutomaticas = []
    this.alertasAutomaticasSel = []

    let response = await axios.get(url.create('/internal/alertas'))
    this.alertas = response.data

    for (let alerta of this.alertas) {
      if (alerta.tipo == 'MANUAL') {
        this.alertasManuales.push(alerta)
      } else {
        this.alertasAutomaticas.push(alerta)
      }
    }
  }

  public async sendAlertas(alertas: Array<any>, aceptar: boolean) {

    var alertasEnviar = []

    for (let alerta of this.alertas) {
      if (alertas.some(function (id) {
        return alerta.identificador === id
      })) {
        var a = {
          alerta: alerta.descripcion,
          correos: alerta.correos,
          accion: this.textoAccion(alerta.accion),
          nombre: this.persona.nombre,
          perfil: this.persona.perfil,
          codigo: this.persona.codigo,
          realizado: aceptar ? 'Acceso concedido' : 'Acceso rechazado',
        }

        alertasEnviar.push(a)
      }
    }

    try {
      var response = await axios.post(url.create('/internal/alertas/mail'), {
        alertas: alertasEnviar,
      })

      if (response.status == 200) {
        if (alertasEnviar.length > 0) {
          this.$bvToast.toast('Se enviaron las respectivas alertas', {
            title: 'Se enviaron las alertas que han sido activadas',
            variant: 'success',
          })
        }
      } else {
        this.$bvToast.toast('No se pudieron enviar las alertas', {
          title: 'No se enviaron las alertas que han sido activadas',
          variant: 'danger',
        })
      }
    } catch (error) {
      this.$bvToast.toast('No se pudieron enviar las alertas', {
        title: 'Sin alertas',
        variant: 'danger',
      })
    }
  }

  public async cargarDatos(codigo) {
    // Cargamos los datos del aforo
    let responseParametrosAforo = await axios.get(
      url.create('/internal/parametros/aforo')
    )
    this.aforo.max = responseParametrosAforo.data['valor']

    try {
      let responseAforoActual = await axios.get(url.create('/internal/aforo/general'))
      this.aforo.cantidad = responseAforoActual.data
    } catch (error) {
      this.aforo.cantidad = '0'
    }

    // Chequeamos si hay aforo
    this.aforoCompleto =
      parseInt(this.aforo.cantidad) >= parseInt(this.aforo.max)

    // Cargamos las encuestas y las alertas
    await this.cargarAlertas()

    try {

      // Traemos los datos de la persona
      let responsePersonal = await axios.get(
        url.create('/internal/vistas/personal/' + codigo)
      )
      this.personalData = await responsePersonal.data

      this.$set(this.persona, 'codigo', this.personalData.CODIGO ?? '---')
      this.$set(this.persona, 'perfil', this.personalData.ROL ?? '---')
      this.$set(this.persona, 'nombre', this.personalData.NOMBRE_COMPLETO ?? '---')
      this.$set(this.persona, 'programa', this.personalData.PROGRAMA ?? '---')

      // this.persona.codigo = this.personalData.CODIGO ?? '---'
      // this.persona.perfil = this.personalData.ROL ?? '---'
      // this.persona.nombre = this.personalData.NOMBRE_COMPLETO ?? '---'
      // this.persona.programa = this.personalData.PROGRAMA ?? '---'
      // this.persona.autorizado = this.persona.horario.length > 0 ? 'Si' : 'No'

      try {

        // Cargamos los horarios
        var responseHorarios = await axios.get(
          url.create('/internal/autorizaciones/estudiante/' + codigo)
        )
        var data = responseHorarios.data
        var dataFin = []

        for (let horario of data) {
          dataFin.push({
            materia: horario.materia,
            nrc: horario.nrc,
            asignatura: horario.asignatura,
            hora_entrada: horario.hora_entrada,
            hora_salida: horario.hora_salida,
            ubicacion: horario.ubicacion,
            dia: this.dias[horario.dia],
          })
        }

        this.$set(this.persona, 'horario', dataFin)

      } catch (error) {
        console.log("Sin horarios")
      }

      if (this.persona.horario.length <= 0) {
        this.alertaHorario = true
      } else {
        this.alertaHorario = true
        for (let hora of this.persona.horario) {
          let entrada = this.parseTime(hora.hora_entrada)
          let salida = this.parseTime(hora.hora_salida)
          let difEntrada = (this.dia.getTime() - entrada.getTime()) / 3600000
          let difSalida = (this.dia.getTime() - salida.getTime()) / 3600000
          if (difEntrada >= -1 && difSalida <= 0) {
            this.alertaHorario = false
            break
          }
        }
      }
      if (this.alertaHorario) {
        this.alertasAutomaticasSel.push('horario')
      }

      //Tuve que moverla aquí porque el rol es necesario para el curso
      this.alertaDelDia = false
      await this.calcularAutomaticas()

      this.botonActivado = true
    } catch (error) {

      //console.log(error)
      this.reiniciarQr()
      this.$bvToast.toast(
        'No se ha encontrado registro con esta identificacion',
        {
          title: 'Sin datos',
          variant: 'danger',
        }
      )
    }
  }

  public parseTime(t) {
    var d = new Date()
    var time = t.match(/(\d+)(?::(\d\d))?(?::(\d\d))?.*/)
    d.setHours(parseInt(time[1]) || 0)
    d.setMinutes(parseInt(time[2]) || 0)
    d.setSeconds(parseInt(time[3]) || 0)
    return d
  }

  public async and(res1: Promise<boolean> | boolean, res2: Promise<boolean> | boolean): Promise<boolean> {
    return !((await Promise.all([res1, res2])).reduce(function (prev, cur) { return prev && cur }, true))
  }

  public async or(res1: Promise<boolean> | boolean, res2: Promise<boolean> | boolean): Promise<boolean> {
    return !((await Promise.all([res1, res2])).reduce(function (prev, cur) { return prev || cur }, false))
  }

  public async not(res: Promise<boolean> | boolean): Promise<boolean> {
    return !(await res)
  }

  public async endpoint(tipo): Promise<boolean> {
    try {
      await axios.get(url.create('/savio/endpoint'), {
        params: {
          codigo: this.codigoTexto,
          perfil: this.persona.perfil,
          tipo: tipo,
        },
      })
      return true
    } catch (error) {
      //this.alertasAutomaticasSel.push(tipo)
      return false
    }
  }

  public async calcularAutomaticas() {
    try {
      // Traemos la periodica
      try {
        let response = await axios.get(
          url.create('/internal/periodicas/ultima'),
          {
            params: {
              codigo: this.codigoTexto,
            },
          }
        )
        this.ingreso = response.data.data
      } catch (error) {
        this.ingreso = {}
      }

      // Traemos la caracterización
      try {
        let response = await axios.get(
          url.create('/internal/caracterizaciones/ultima'),
          {
            params: {
              codigo: this.codigoTexto,
            },
          }
        )
        this.caracterizacion = response.data.data
      } catch (error) {
        this.caracterizacion = {}
      }

      // Calculamos las alertas automaticas
      let horas =
        Math.abs(
          new Date(this.ingreso.created_at).getTime() - new Date().getTime()
        ) / 3600000

      if (horas > 24 || _.isEmpty(this.ingreso)) {
        this.alertaDelDia = true
        this.alertasAutomaticasSel.push('sin_encuesta')
      }
      let context = {
        not: this.not,
        endpoint: this.endpoint,
        respuestas: this.ingreso.respuestas,
        caracterizacion: this.caracterizacion.respuestas,
        aforoCompleto: this.aforoCompleto,
        codigo: this.persona.codigo,
        perfil: this.persona.perfil,
      }

      //if (respuestas.viajeInternacional != 'NO') {
      //  this.alertasAutomaticasSel.push('viajes_internacionales')
      //}

      //if (respuestas.sintomasDiarios != 'NO') {
      //  this.alertasAutomaticasSel.push('presunto_caso')
      //}

      //if (respuestas.enfermedadAltoRiesgo != 'NO') {
      //  this.alertasAutomaticasSel.push('comorbilidad')
      //}

      //if (respuestas.edadesPersonasConvive != 'NINGUNO') {
      //  this.alertasAutomaticasSel.push('convive')
      //}

      //if (respuestas.afiliacionEps != 'SI') {
      //  this.alertasAutomaticasSel.push('sin_eps')
      //}

      //var imc = respuestas.peso / (respuestas.altura * respuestas.altura)
      //if (respuestas.embarazo === 'SI' || imc > 30) {
      //  this.alertasAutomaticasSel.push('predisposicion')
      //}

      let self = this
      this.alertasAutomaticasPerfil.forEach(async function (alerta) {
        try {
          let res = seval(alerta.condicion || 'false', context)
          if (
            (await Promise.resolve(res))
          ) {
            if (!self.alertasAutomaticasSel.includes(alerta.identificador)) {
              self.alertasAutomaticasSel.push(alerta.identificador)
            }
          }
        } catch (ex) {
          //Do nothing
        }
      })

    } catch (error) {
      this.alertaDelDia = true
      this.alertasAutomaticasSel.push('sin_encuesta')
      //console.log(error)
    }
  }

  public cargarModal(ingreso) {
    if (ingreso) {
      this.modalIngreso = true
    } else {
      this.modalDenegado = true
    }
  }

  public async registrarIngreso(aceptar = true) {
    try {
      this.botonActivado = false
      this.modalIngreso = false
      this.modalDenegado = false

      let todasAlertas = this.alertasManualesSel
        .concat(this.alertasAutomaticasSel)

      var registro = {
        codigo: this.persona.codigo,
        nombre: this.persona.nombre,
        perfil: this.persona.perfil,
        observaciones: this.observaciones,
        alertas: todasAlertas,
        acceso: aceptar,
      }

      let response = aceptar ? await axios.post(url.create('/internal/ingreso'), registro) : await axios.post(
        url.create('/internal/ingreso/rechazado'),
        registro
      )

      //console.log(response.data)
      let respuesta = response.data
      let errorIngreso = false
      if (respuesta != 0) {
        if (respuesta === 1) {
          this.$bvToast.toast(
            'El usuario ya se encuentra dentro de las intalaciones',
            {
              title: 'Error al crear el registro',
              variant: 'danger',
            }
          )
        } else {
          this.$bvToast.toast('Acceso no permitido', {
            title: 'Atención',
            variant: 'warning',
          })
        }
        errorIngreso = true
      }

      if (response.status == 200 && !errorIngreso) {
        await this.sendAlertas(todasAlertas, aceptar)
      }

      this.reiniciarQr()
    } catch (error) {
      this.$bvToast.toast('No se ha podido crear el registro de entrada', {
        title: 'Error al crear el registro',
        variant: 'danger',
      })
      this.botonActivado = true
    }
  }

  public async cargarAlertasAcciones() {
    let response = await axios.get(url.create('/public/enums/acciones_alerta'))
    this.alertasAcciones = response.data
  }

  public textoAccion(accion) {
    return (
      this.alertasAcciones.find(function (item) {
        return item.key === accion
      }).value || 'Sin acción'
    )
  }

  @Watch('persona.temperatura')
  public onPersonaTemperaturaChange(val) {
    let self = this
    _.debounce(
      function (val) {
        val = Number.isFinite(val) ? val : Number.parseFloat(val)
        if (val >= 38) {
          if (!self.alertasAutomaticasSel.includes('temperatura')) {
            self.alertasAutomaticasSel.push('temperatura')
          }
        } else {
          const index = self.alertasAutomaticasSel.indexOf('temperatura')
          if (index > -1) {
            self.alertasAutomaticasSel.splice(index, 1)
          }
        }
      },
      150,
      {
        leading: true,
        trailing: false,
      }
    )(val)
  }

  // Cargar spiner mientras carga el componente
  public created() {
    this.cargarAlertasAcciones()
  }
}
</script>

<style lang="scss"></style>
